'use client';

import {
  BigPartnersSection,
  EcosystemProductsSection,
  HeroSection,
  InfoCardsGrid,
  PartnerCategories,
  PartnerLogoMarquee,
  PartnersTypeform,
  UltrasignalSection,
  VisionSection,
} from 'components/partners';
import { Banner } from 'components/landing';
import type { BannerContentProps } from 'components/landing/Banner';
import { ButtonV2, useModal } from 'components/shared';
import React from 'react';
import styles from './partners-client.module.css';

const CustomBannerContent: React.FC<BannerContentProps> = ({
  title,
  subtitle,
  cta,
  ctaAlt,
}) => {
  return (
    <>
      {(title || subtitle) && (
        <div className={styles.customTextStack}>
          {!!title && <h1 className={styles.customTitle}>{title}</h1>}
          {!!subtitle && (
            <p className={styles.customSubtitle}>{subtitle}</p>
          )}
        </div>
      )}

      {(cta || ctaAlt) && (
        <div className={styles.customButtons}>
          {!!cta && <ButtonV2 {...cta}>{cta.children}</ButtonV2>}
          {!!ctaAlt && <ButtonV2 {...ctaAlt}>{ctaAlt.children}</ButtonV2>}
        </div>
      )}
    </>
  );
};

const Partners = () => {
  const ecosystemRef = React.useRef<HTMLElement>(null);
  const ModalClient = useModal();

  const scrollToEcosystem = () => {
    ecosystemRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <>
      <HeroSection onExploreSolutions={scrollToEcosystem} />
      <PartnerLogoMarquee />
      <PartnerCategories />

      {/* Solutions */}
      <EcosystemProductsSection ref={ecosystemRef} />
      <VisionSection />
      <UltrasignalSection />
      {/* Solutions End */}

      <BigPartnersSection />

      <InfoCardsGrid />

      <Banner
        title="The future of health, built together"
        // subtitle="A quiet yet powerful sleep monitor to help you rest better."
        cta={{
          href: '/partners', // TODO: change to typeform
          children: 'Become a partner',
          onClick: (e) => {
            e.preventDefault();
            ModalClient.set(<PartnersTypeform />);
            ModalClient.setCloseButtonTheme('light');
            ModalClient.show();
          },
        }}
        backgroundStyles={{
          objectPosition: 'bottom',
        }}
        background={{
          type: 'image',
          src: {
            mobile: 'web_v2/partners/partners-outro-bg-resp.png',
            web: 'web_v2/partners/partners-outro-bg.png',
          },
          alt: 'Ultrahuman Home device on dark surface with blurred background of person wearing ring',
        }}
        position="center"
        contentColor="#fff"
        sectionStyles={{ height: '100vh' }}
        CustomContentComponent={CustomBannerContent}
      />
    </>
  );
};

export default Partners;
